<div
  class="d-inline-flex align-items-start flex-column input-text-sizing"
  [formGroup]="parentFormGroup"
>
  <div class="field-label">{{ label + asterisk }}</div>
  <mat-form-field
    class="editor inline-editable-editor"
    floatLabel="auto"
    attr.aria-label="{{ formElementId }}"
  >
    <input
      [id]="formElementId"
      type="text"
      matInput
      [formControlName]="formElementId"
    />
    <mat-error
      class="invalid-feedback"
      *ngIf="control.invalid && (control.dirty || control.touched)"
    >
      <div *ngIf="control.errors?.['maxlength'] as maxLengthError">
        {{ validationErrorLabel }} must be no more than
        {{ maxLengthError.requiredLength }} characters long.
      </div>
      <div *ngIf="control.errors?.['pattern']">
        Invalid characters in {{ validationErrorLabel }}.
      </div>
    </mat-error>
  </mat-form-field>
</div>
